module.exports = __webpack_public_path__ + "static/media/logoName.7778a683.svg";